import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { BookMarked, Dumbbell } from "lucide-react";

export function DraggablePlay({ play }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `play:${play.id}`,
    data: { type: "play", play },
  });
  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      data-testid={`lib-play-${play.id}`}
      style={{ opacity: isDragging ? 0.4 : 1 }}
      className="cursor-grab active:cursor-grabbing bg-background border border-surface-3 hover:border-amber px-3 py-2 transition-colors select-none"
    >
      <div className="flex items-center gap-2">
        <BookMarked className="w-3 h-3 text-amber shrink-0" />
        <div className="text-[9px] font-condensed uppercase tracking-widest text-slate-500">
          {play.side.replace("_", " ")}
        </div>
      </div>
      <div className="text-xs font-semibold mt-1 truncate">{play.name}</div>
      <div className="text-[10px] text-slate-500 truncate">{play.formation}</div>
    </div>
  );
}

export function DraggableDrill({ drill }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `drill:${drill.id}`,
    data: { type: "drill", drill },
  });
  return (
    <div
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      data-testid={`lib-drill-${drill.id}`}
      style={{ opacity: isDragging ? 0.4 : 1 }}
      className="cursor-grab active:cursor-grabbing bg-background border border-surface-3 hover:border-amber px-3 py-2 transition-colors select-none"
    >
      <div className="flex items-center gap-2">
        <Dumbbell className="w-3 h-3 text-amber shrink-0" />
        <div className="text-[9px] font-condensed uppercase tracking-widest text-slate-500">
          {(drill.category || "general").replace("_", " ")} · {drill.duration_min || 10}m
        </div>
      </div>
      <div className="text-xs font-semibold mt-1 truncate">{drill.name}</div>
      <div className="text-[10px] text-slate-500 truncate">{drill.purpose || drill.difficulty || ""}</div>
    </div>
  );
}

export function DragPreview({ activeDrag }) {
  return (
    <>
        {activeDrag?.kind === "play" && (
          <div className="bg-surface border border-amber px-3 py-2 shadow-2xl">
            <div className="text-[9px] font-condensed uppercase tracking-widest text-amber">
              {activeDrag.play.side.replace("_", " ")}
            </div>
            <div className="text-xs font-semibold">{activeDrag.play.name}</div>
          </div>
        )}
        {activeDrag?.kind === "drill" && (
          <div className="bg-surface border border-amber px-3 py-2 shadow-2xl">
            <div className="text-[9px] font-condensed uppercase tracking-widest text-amber">
              {(activeDrag.drill.category || "general").replace("_", " ")}
            </div>
            <div className="text-xs font-semibold">{activeDrag.drill.name}</div>
          </div>
        )}
        {activeDrag?.kind === "period" && (
          <div className="bg-surface border border-amber px-3 py-2 shadow-2xl text-xs font-semibold">
            {activeDrag.period?.name}
          </div>
        )}
    </>
  );
}
